import Button from '@material-ui/core/Button';
import compose from 'recompose/compose';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import overlayStyle from 'shared/materialUIFormat/overlayFormatting';
import PropTypes from 'prop-types';
import React from 'react';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { actions as navBarActions } from 'redux/domain/NavBar';
import { actions as storeLocationActions } from 'redux/domain/StoreLocation';
import KioskLog from 'models/KioskLog';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCancelTokenSource } from 'api/Helpers';
import {
	getStoreLocation,
	getStores,
	setInitialStore,
	setStoreLocation,
} from 'shared/utils/storeLocationHelpers';
import { withStyles } from '@material-ui/core/styles';
import styles from '../styles.css';
import withRouter from '../../../shared/utils/WithRouter';

const stylesMUI = theme => ({
	okayButton: {
		backgroundColor: theme.palette.common.white,
		marginTop: 20,
	},
	selectInput: {
		color: theme.palette.text.main,
	},
	selectStore: {
		bottom: '0.3em',
		marginLeft: 3,
		marginBottom: '1.1em',
		fontSize: '15px',
	},
	selectStoreHeader: {
		fontFamily: theme.typography.fontFamily,
	},
});

class StoreLocationContainer extends React.Component {
	constructor(props) {
		super(props);
		const stores = getStores();
		const currentStore = getStoreLocation();
		const defaultStore = currentStore !== 0 ? currentStore : stores[0].Id;
		this.state = {
			selectedStore: defaultStore,
			stores,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveSelectedLocation = this.saveSelectedLocation.bind(this);
		this.cancelTokenSource = getCancelTokenSource();
	}

	handleChange(value) {
		this.setState({ selectedStore: value });
	}

	handleClose() {
		if (getStoreLocation() !== 0) {
			this.props.closeStoreModal();
		}
	}

	saveSelectedLocation() {
		const { saveSelectedLocation, customer } = this.props;
		try {
			this.cancelTokenSource = getCancelTokenSource();
			saveSelectedLocation(this.cancelTokenSource.token, this.state.selectedStore, customer.id);
		} catch (e) {
			const log = new KioskLog(e, `warehouseId=${this.state.selectedStore}`, `customerId=${customer.id}`);
			log.postMessage();
		}
	}

	render() {
		const { closeMainDrawer, closeStoreModal, storeModalOpen, classes } = this.props;

		return (
			<Modal
				aria-labelledby="modal-label"
				style={overlayStyle.storeModal}
				BackdropProps={{ style: overlayStyle.backdropStyle }}
				onClose={() => this.handleClose()}
				open={storeModalOpen}
			>
				<div style={overlayStyle.modalSection}>
					<div className={styles.storeLocation}>
						<h3 className={classes.selectStoreHeader}>Please select a Kiosk Store Location</h3>
						<Select
							value={this.state.selectedStore}
							onChange={event => {
								this.handleChange(event.target.value);
							}}
							key={this.state.selectedStore}
							className={classes.SelectStore}
							MenuProps={{
								transformOrigin: { vertical: 'top', horizontal: 'left' },
								getContentAnchorEl: null,
								// This is the same index as the store modal, keep them the same
								style: { zIndex: 1600 },
							}}
							inputProps={{ className: classes.selectInput }}
						>
							{this.state.stores.map(store => (
								<MenuItem key={store.Id} value={store.Id}>
									{store.Name}
								</MenuItem>
							))}
						</Select>
						<Button
							variant="contained"
							className={classes.okayButton}
							onClick={() => {
								if (getStoreLocation() === 0) {
									setInitialStore(this.state.selectedStore);
								}
								setStoreLocation(this.state.selectedStore);
								this.saveSelectedLocation();
								closeStoreModal();
								closeMainDrawer();
								this.props.router.navigate('/');
							}}
						>
							<Typography>Okay</Typography>
						</Button>
					</div>
				</div>
			</Modal>
		);
	}
}

StoreLocationContainer.propTypes = {
	closeMainDrawer: PropTypes.func.isRequired,
	closeStoreModal: PropTypes.func.isRequired,
	storeModalOpen: PropTypes.bool.isRequired,
	saveSelectedLocation: PropTypes.func.isRequired,
	classes: PropTypes.shape({
		okayButton: PropTypes.string,
		selectInput: PropTypes.string,
		selectStore: PropTypes.string,
		selectStoreHeader: PropTypes.string,
	}).isRequired,
};

const mapStateToProps = state => {
	const storeModalOpen = state.storeLocation.get('storeModalOpen');
	const customer = state.user.get('customer');
	return {
		storeModalOpen,
		customer,
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...navBarActions, ...storeLocationActions }, dispatch);

// for testing purposes
export { StoreLocationContainer as StoreLocationContainerClass };
export default withRouter(compose(
	connect(mapStateToProps, mapDispatchToProps),
	withStyles(stylesMUI, { name: 'StoreLocationContainer' }),
)(StoreLocationContainer));
